export default __webpack_public_path__ + "static/media/Lato-Light.db4ac512.ttf";